export default __webpack_public_path__ + "static/10A-948e2516d229e252807109ec2949964a.png";